import { Type } from "../../../models/configuration/definitions/widget";

const UNITARY_SHARE_UNSUPPORTED_WIDGETS: Type[] = [
  Type.Associations,
  Type.Baskets,
  Type.Mosaic,
  Type.Report,
  Type.Search,
];
// In element share, backoffice advanced search is not implemented => we need to disable widget with advanced search to avoid API Error
export const isWidgetUnsupportedInUnitaryShare = (widgetType: Type) =>
  UNITARY_SHARE_UNSUPPORTED_WIDGETS.includes(widgetType);
